<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="运输费用" left-text="返回" left-arrow @click-left="onClickLeft" right-text="+" @click-right="onClickRight" fixed></van-nav-bar>
        <div class="psiDetailCont">
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-model="loading" :finished="finished" @load="onLoad"  :finished-text="finishText">
					<div v-for="item in list" class="card" :key="item.uuid" @click="openDetail(item)">
						<template>
							<table class="layout">
								<tr>
									<td class="content" style="padding-left: 20px;">
										<p><span>{{item.serialNumber}}</span></p>
									</td>
									<td class="content">
										<p><span>{{item.createTime}}</span></p>
									</td>
								</tr>
								<tr>
									<td class="content" style="padding-left: 20px;">
										<p><span>司机:{{item.driver}}</span></p>
									</td>
									<td class="content"></td>
								</tr>
								<tr>
									<td class="content" style="padding-left: 20px;">
										<p><span>车牌号:{{item.carNum}}</span></p>
									</td>
									<td class="content">{{item.currentState}}</td>
								</tr>
								<tr>
									<td class="content" style="padding-left: 20px;">
										<p><span>出车地点:{{item.startPlace}}</span></p>
									</td>
									<td class="content"></td>
								</tr>
								<tr>
									<td class="content" style="padding-left: 20px;">
										<p><span>到达地点:{{item.endPlace}}</span></p>
									</td>
									<td class="content"></td>
								</tr>
								<tr>
									<td class="content" style="padding-left: 20px;">
										<p><span>费用总额:{{item.费用总额}}</span></p>
									</td>
									<td class="content"></td>
								</tr>
							</table>
						</template>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
    </div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,NavBar} from 'vant';
	import barcodeService from "../../../service/barcodeService";
    import {formatDictionary} from "../../../utils/dictionary";
	import moment from "moment";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				finishText: "没有更多了"
            }
        },
      
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
			[NavBar.name]: NavBar,
        },
        computed: {
            
        },
        created: async function () {
            
        },
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await barcodeService.getFreightList(this.pageIndex);
                resp.data.Data.data.forEach(item => {
                    item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm');
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
                if(resp.data.Data.total == 0){
					this.finishText="暂无运输费用单";
				}else{
                	this.finishText="没有更多了";
				}
                // console.log(this.list)
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
            openDetail(item){
							this.$router.push({
								path: "freightDetail",
								query: {
									formId: item.uuid,
									status:	item.status,
									nextStepId:item.nextStepId,
									wfId:item.wfId
								}
							})
					
            },
		
			onClickLeft(){
				 window.open('/colseWebView');
			},
			onClickRight(){
				this.$router.push("/customized/guohuanhuanbao/freightDetail");
			},
        }
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}

	.psiDetailCont{
		width:100%;
		margin:0 auto;
		margin-top:120px;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
</style>